import { useEffect, useState } from 'react';

const useIsMobilePWA = () => {
    const [isMobilePWA, setIsMobilePWA] = useState(false);

    useEffect(() => {
        const checkIsMobilePWA = () => {
            const isStandalone =
                window.matchMedia('(display-mode: standalone)').matches ||
                window.navigator.standalone === true;
            const isMobile = window.innerWidth < 640;
            setIsMobilePWA(isStandalone && isMobile);
        };

        checkIsMobilePWA();
        window.addEventListener('resize', checkIsMobilePWA);
        return () => window.removeEventListener('resize', checkIsMobilePWA);
    }, []);

    return isMobilePWA;
};

export default useIsMobilePWA;
